module.exports = __webpack_public_path__ + "img/Banner-Feet-dwnszd.9531d3f1.jpg";